import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';

/**
 * Email Service - Utility functions for sending emails
 * 
 * This service uses Firebase Cloud Functions to send emails via nodemailer
 * instead of the previous mailgun implementation.
 */

// Initialize Firebase Functions
const functions = getFunctions(app);

/**
 * Test the email configuration
 * 
 * @returns {Promise<Object>} - The result of the configuration test
 */
export const testEmailConfig = async () => {
  try {
    const testEmailConfigFunction = httpsCallable(functions, 'testEmailConfig');
    const result = await testEmailConfigFunction();
    
    return result.data;
  } catch (error) {
    console.error('Error testing email configuration:', error);
    return {
      success: false,
      message: 'Failed to test email configuration'
    };
  }
};

/**
 * Send an email using Firebase Cloud Functions
 * 
 * @param {Object} emailData - The email data
 * @param {string} emailData.recipientEmail - The recipient's email address
 * @param {string} emailData.subject - The email subject
 * @param {string} emailData.senderName - The sender's name
 * @param {string} emailData.receiverName - The receiver's name
 * @param {string} emailData.messageText - The message text
 * @param {string} emailData.adTitle - The title of the ad (optional)
 * @param {string} emailData.adId - The ID of the ad (optional)
 * @returns {Promise<Object>} - The result of the email sending operation
 */
export const sendEmail = async (emailData) => {
  try {
    const sendEmailFunction = httpsCallable(functions, 'sendEmail');
    const result = await sendEmailFunction(emailData);
    
    console.log('Email sent successfully:', result.data);
    return result.data;
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
};

/**
 * Send a test email using Firebase Cloud Functions
 * 
 * @param {string} recipientEmail - The recipient's email address
 * @param {string} message - The test message
 * @returns {Promise<Object>} - The result of the email sending operation
 */
export const sendTestEmail = async (recipientEmail, message = "This is a test email from Totly.") => {
  try {
    const sendTestEmailFunction = httpsCallable(functions, 'sendTestEmail');
    const result = await sendTestEmailFunction({
      recipientEmail,
      message
    });
    
    console.log('Test email sent successfully:', result.data);
    return result.data;
  } catch (error) {
    console.error('Error sending test email:', error);
    throw error;
  }
}; 